import {
  FETCH_FAVORITES,
  FETCH_FAVORITES_FAILED,
  FETCH_FAVORITES_SUCCEED,
  FETCH_UPDATE_FAVORITES,
  FETCH_UPDATE_FAVORITES_SUCCEED,
  FETCH_UPDATE_FAVORITES_FAILED,
  FETCH_DELETE_FAVORITES,
  FETCH_DELETE_FAVORITES_SUCCEED,
  FETCH_DELETE_FAVORITES_FAILED,
  LOCAL_FETCH_FAVORITES,
  LOCAL_FETCH_FAVORITES_FAILED,
  LOCAL_FETCH_FAVORITES_SUCCEED,
  LOCAL_FETCH_UPDATE_FAVORITES,
  LOCAL_FETCH_UPDATE_FAVORITES_SUCCEED,
  LOCAL_FETCH_UPDATE_FAVORITES_FAILED,
  LOCAL_FETCH_DELETE_FAVORITES,
  LOCAL_FETCH_DELETE_FAVORITES_SUCCEED,
  LOCAL_FETCH_DELETE_FAVORITES_FAILED,
} from './action_types';

export default {
  fetchFavoritesAction: (params) => ({
    type: FETCH_FAVORITES,
    params,
  }),
  fetchFavoritesActionSucceed: (data) => ({
    type: FETCH_FAVORITES_SUCCEED,
    data,
  }),
  fetchFavoritesActionFailed: (err) => ({
    type: FETCH_FAVORITES_FAILED,
    err,
  }),

  fetchUpdateFavoritesAction: (params) => ({
    type: FETCH_UPDATE_FAVORITES,
    params,
  }),
  fetchUpdateFavoritesActionSucceed: (data) => ({
    type: FETCH_UPDATE_FAVORITES_SUCCEED,
    params: {
      data,
    },
  }),
  fetchUpdateFavoritesActionFailed: (err) => ({
    type: FETCH_UPDATE_FAVORITES_FAILED,
    err,
  }),

  fetchDeleteFavoritesAction: (params) => ({
    type: FETCH_DELETE_FAVORITES,
    params,
  }),

  fetchDeleteFavoritesActionSucceed: (data) => ({
    type: FETCH_DELETE_FAVORITES_SUCCEED,
    params: {
      data,
    },
  }),
  fetchDeleteFavoritesActionFailed: (err) => ({
    type: FETCH_DELETE_FAVORITES_FAILED,
    err,
  }),

  // login === false

  localFetchFavoritesAction: (params) => ({
    type: LOCAL_FETCH_FAVORITES,
    params,
  }),
  localFetchFavoritesActionSucceed: (data) => ({
    type: LOCAL_FETCH_FAVORITES_SUCCEED,
    data,
  }),
  localFetchFavoritesActionFailed: (err) => ({
    type: LOCAL_FETCH_FAVORITES_FAILED,
    err,
  }),

  localFetchUpdateFavoritesAction: (params) => ({
    type: LOCAL_FETCH_UPDATE_FAVORITES,
    params,
  }),
  localFetchUpdateFavoritesActionSucceed: (data) => ({
    type: LOCAL_FETCH_UPDATE_FAVORITES_SUCCEED,
    params: {
      data,
    },
  }),
  localFetchUpdateFavoritesActionFailed: (err) => ({
    type: LOCAL_FETCH_UPDATE_FAVORITES_FAILED,
    err,
  }),

  localFetchDeleteFavoritesAction: (params) => ({
    type: LOCAL_FETCH_DELETE_FAVORITES,
    params,
  }),

  localFetchDeleteFavoritesActionSucceed: (data) => ({
    type: LOCAL_FETCH_DELETE_FAVORITES_SUCCEED,
    params: {
      data,
    },
  }),
  localFetchDeleteFavoritesActionFailed: (err) => ({
    type: LOCAL_FETCH_DELETE_FAVORITES_FAILED,
    err,
  }),
};
